/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for AiResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCustomerAnalysisResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AiResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCustomerAnalysis(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCustomerAnalysisResponse, unknown> & { defaultValue: NoInfer<GetCustomerAnalysisResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerAnalysisResponse>;
    getCustomerAnalysis(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerAnalysisResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerAnalysisResponse | undefined>;
    getCustomerAnalysis(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerAnalysisResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerAnalysisResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Ai/Customer/${typeof customerId === 'function' ? customerId() : customerId}/Analysis`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
